import { blurIfPrimaryClick } from 'lib';
import { licon } from 'lib/licon';
import menuKeyboardInteractions from 'lib/menuKeyboardInteractions';
import { confirm } from 'lib/view';
import { userComplete } from 'lib/view/userComplete';
import { writeTextClipboard, text as xhrText } from 'lib/xhr';

import topBar from './topBar';

export function addWindowHandlers() {
  let animFrame: number;

  window.addEventListener('resize', () => {
    cancelAnimationFrame(animFrame);
    animFrame = requestAnimationFrame(setViewportHeight);
  });

  // ios safari vh correction
  function setViewportHeight() {
    document.body.style.setProperty('---viewport-height', `${window.innerHeight}px`);
  }
}

export function addDomHandlers() {
  topBar();
  menuKeyboardInteractions();

  $('#main-wrap')
    .on('click', '.copy-me__button', function (this: HTMLElement, e: Event) {
      blurIfPrimaryClick(e);
      const showCheckmark = () => {
        $(this).attr('data-icon', licon.Checkmark).removeClass('button-metal');
        setTimeout(() => $(this).attr('data-icon', licon.Clipboard).addClass('button-metal'), 1000);
      };
      const fetchContent = $(this).parent().hasClass('fetch-content');
      $(this.parentElement!.firstElementChild).each(function (this: HTMLInputElement | HTMLAnchorElement) {
        try {
          if (this instanceof HTMLAnchorElement) {
            if (fetchContent) writeTextClipboard(this.href, showCheckmark);
            else navigator.clipboard.writeText(this.href).then(showCheckmark);
          } else if (this instanceof HTMLInputElement) {
            navigator.clipboard.writeText(this.value).then(showCheckmark);
          }
        } catch (e) {
          console.error(e);
        }
      });
      return false;
    })
    .on('click', '.yes-no-confirm, .ok-cancel-confirm', async function (this: HTMLElement, e: Event) {
      if (!e.isTrusted) return;
      e.preventDefault();
      const [confirmText, cancelText] = this.classList.contains('yes-no-confirm')
        ? [i18n.site.yes, i18n.site.no]
        : [i18n.site.ok, i18n.site.cancel];
      if (await confirm(this.title || 'Confirm this action?', confirmText, cancelText))
        (e.target as HTMLElement)?.click();
    })
    .on('click', 'a.bookmark', function (this: HTMLAnchorElement) {
      const t = $(this).toggleClass('bookmarked');
      xhrText(this.href, { method: 'post' });
      const count = (parseInt(t.text(), 10) || 0) + (t.hasClass('bookmarked') ? 1 : -1);
      t.find('span').html(count > 0 ? String(count) : '');
      return false;
    });

  $('body').on('click', '.relation-button', function (this: HTMLAnchorElement) {
    const $a = $(this).addClass('processing').css('opacity', 0.3);
    const dropdownOverflowParent = this.closest<HTMLElement>('.dropdown-overflow');
    if (dropdownOverflowParent) {
      dropdownOverflowParent.dispatchEvent(new CustomEvent('reload', { detail: this.href }));
    } else {
      xhrText(this.href, { method: 'post' }).then(html => {
        if ($a.hasClass('aclose')) $a.hide();
        else if (html.includes('relation-actions')) $a.parent().replaceWith(html);
        else $a.replaceWith(html);
      });
    }
    return false;
  });

  $('.user-autocomplete').each(function (this: HTMLInputElement) {
    const focus = this.autofocus;
    const start = () =>
      userComplete({
        input: this,
        friend: !!this.dataset.friend,
        tag: this.dataset.tag as any,
        focus,
      });

    if (focus) start();
    else $(this).one('focus', start);
  });
}
